import React from 'react'
import PropTypes from 'prop-types'
import { Rows, SpinningMask } from 'src/components'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './Hint.scss'

const Hint = ({ loading, color, label, children, ...domProps }) => {
  color = getColor(color)

  return (
    <Rows
      gap="0"
      {...mergeProps()(
        { className: [styles.container, { [styles.withoutLabel]: !label }], style: { color, borderColor: color } },
        domProps
      )}
    >
      <div className={styles.background} style={{ backgroundColor: color }} />
      <Rows className={styles.content} layout={!!label ? 'auto 1' : undefined}>
        {!!label && (
          <div className={styles.label} style={{ backgroundColor: color }}>
            {label}
          </div>
        )}
        <SpinningMask loading={loading}>
          <Rows>{children}</Rows>
        </SpinningMask>
      </Rows>
    </Rows>
  )
}

Hint.defaultProps = {
  color: 'primary',
}

Hint.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string,
  label: PropTypes.node,
  children: PropTypes.node,
}

export default Hint
